import { normalizeGroupTripList } from './groupTripModel';

export const GROUP_TRIP_DISCOVERY_SORTS = ['LATEST', 'START_AT_ASC'];
export const DEFAULT_GROUP_TRIP_DISCOVERY_SORT = 'LATEST';
export const DEFAULT_GROUP_TRIP_DISCOVERY_LIMIT = 20;

function trim(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/** datetime-local / ISO → backend LocalDateTime（YYYY-MM-DDTHH:mm:ss）。 */
export function serializeDiscoveryDateTime(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().slice(0, 19);
}

export function emptyDiscoveryFilters(overrides = {}) {
  return {
    q: '',
    startFrom: '',
    startTo: '',
    hasAvailableSlots: false,
    sort: DEFAULT_GROUP_TRIP_DISCOVERY_SORT,
    ...overrides,
  };
}

export function isDiscoveryDateRangeValid(startFrom, startTo) {
  const from = serializeDiscoveryDateTime(startFrom);
  const to = serializeDiscoveryDateTime(startTo);
  if (!from || !to) return true;
  return from <= to;
}

export function isDiscoveryFilterActive(filters) {
  if (!filters) return false;
  return Boolean(
    trim(filters.q)
    || filters.startFrom
    || filters.startTo
    || filters.hasAvailableSlots === true
    || (filters.sort && filters.sort !== DEFAULT_GROUP_TRIP_DISCOVERY_SORT),
  );
}

/** 組裝 listPublic query；略過空白 optional 參數。 */
export function buildListPublicParams(filters, { cursor = null, limit = DEFAULT_GROUP_TRIP_DISCOVERY_LIMIT } = {}) {
  const sort = GROUP_TRIP_DISCOVERY_SORTS.includes(filters?.sort)
    ? filters.sort
    : DEFAULT_GROUP_TRIP_DISCOVERY_SORT;
  const params = { limit, sort };

  const q = trim(filters?.q);
  if (q) params.q = q;

  const startFrom = serializeDiscoveryDateTime(filters?.startFrom);
  if (startFrom) params.startFrom = startFrom;

  const startTo = serializeDiscoveryDateTime(filters?.startTo);
  if (startTo) params.startTo = startTo;

  if (filters?.hasAvailableSlots === true) {
    params.hasAvailableSlots = true;
  }

  if (cursor) {
    if (sort === 'START_AT_ASC') {
      if (cursor.nextCursorStartAt) params.cursorStartAt = cursor.nextCursorStartAt;
    } else if (cursor.nextCursorCreateTime) {
      params.cursorCreateTime = cursor.nextCursorCreateTime;
    }
    if (cursor.nextCursorId != null) params.cursorId = cursor.nextCursorId;
  }

  return params;
}

export function normalizeGroupTripDiscoveryPage(payload, t) {
  const list = normalizeGroupTripList(payload, t);
  return {
    items: list.items,
    hasMore: Boolean(payload?.hasMore),
    nextCursor: {
      nextCursorCreateTime: payload?.nextCursorCreateTime || null,
      nextCursorStartAt: payload?.nextCursorStartAt || null,
      nextCursorId: payload?.nextCursorId ?? null,
    },
  };
}

export function appendGroupTripDiscoveryItems(current, nextItems) {
  const seen = new Set((current || []).map((item) => item.groupTripId));
  const merged = [...(current || [])];
  for (const item of nextItems || []) {
    if (item?.groupTripId == null || seen.has(item.groupTripId)) continue;
    seen.add(item.groupTripId);
    merged.push(item);
  }
  return merged;
}

export function formatDiscoveryDateTime(value, locale) {
  if (!value) return '';
  try {
    const tag = locale?.replace('_', '-') || undefined;
    return new Intl.DateTimeFormat(tag, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
  } catch {
    return String(value);
  }
}
